module.exports = __webpack_public_path__ + "static/img/logo_impo_azul.1dbfd8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/logo_impo_azul.png
// module id = IleB
// module chunks = 232